import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceType} from "../../../deliveries/types/service.type";

export class PlanningLocationSettingsFormComponent implements IController {

  locationSettings: any;
  hideActivation: boolean;
  isActive: boolean;
  depots: any;
  depotIds: any;
  serviceType: ServiceType;
  branchIds: any;
  isDisabled: boolean;
  onChange: Function;

  constructor() {
  }

  $onInit() {
  }

  onToggleDeparturePoint() {
    this.locationSettings.departurePointType = this.locationSettings.departurePointType === 'UNDEFINED' ? 'DEPOT' : "UNDEFINED";
    this.locationSettings.departurePoint = undefined;
    this.locationSettings.departureId = undefined;
    this._locationChange(this.locationSettings);
  }

  onDeparturePointTypeChange(type) {
    if (this.locationSettings.departurePointType !== type) {
      this.locationSettings.departurePointType = type;
      this.locationSettings.departurePoint = undefined;
      this.locationSettings.departureId = undefined;
    }
    this._locationChange(this.locationSettings);
  }

  onToggleDestinationPoint() {
    this.locationSettings.destinationPointType = this.locationSettings.destinationPointType === 'UNDEFINED' ? 'DEPOT' : "UNDEFINED";
    this.locationSettings.destinationPoint = undefined;
    this.locationSettings.destinationId = undefined;
    this._locationChange(this.locationSettings);
  }

  onDestinationPointTypeChange(type) {
    if (this.locationSettings.destinationPointType !== type) {
      this.locationSettings.destinationPointType = type;
      this.locationSettings.destinationPoint = undefined;
      this.locationSettings.destinationId = undefined;
    }
    this._locationChange(this.locationSettings);
  }

  onAddressSelect(allocationAddressRef, address) {
    this.locationSettings[allocationAddressRef] = address;
    this._locationChange(this.locationSettings);
  }

  onDepotSelect(allocationDepotRef, locationPointRef, depot) {
    const selectedDepot = this.depots ? _.find(this.depots, (d) => {
      return _.isEqual(d.id, _.get(depot, 'id'));
    }) : depot;

    this.locationSettings[allocationDepotRef] = _.get(selectedDepot, 'id');
    this.locationSettings[locationPointRef] = _.get(selectedDepot, 'address');
    this._locationChange(this.locationSettings);
  }

  private _locationChange(locationSettings) {
    this.onChange({locationSettings: locationSettings});
  }

}


angular
  .module('bringoz.admin.commons')
  .component('planningLocationSettingsForm', {
    require: {
      form: '^form'
    },
    bindings: {
      locationSettings: '<',
      depots: '<?',
      depotIds: '<?',
      branchIds: '<?',
      serviceType: '<?',
      isDisabled: '<?',
      onChange: '&'
    },
    template: require('./planning-location-settings-form.html').default,
    controller: PlanningLocationSettingsFormComponent
  });
